<template>
  <div>
    <div class="vx-row mb-6" style="width:50%">
        <div class="vx-col sm:w-1/3 w-full flex items-center">
            <span>Territory</span>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
            <territory-filter
                :showTitle="false"
                :full="true"
                :multiSelect="true"
            />
        </div>
    </div>
    <div class="vx-row mb-6" style="width: 50%">
      <div class="vx-col sm:w-1/3 w-full flex items-center">
        <span>Distribution Chanel</span>
        <!-- <feather-icon title="Reset" icon="RefreshCwIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" class="ml-2" @click.stop="resetDateFilter('openkeydate')"/> -->
      </div>
      <div class="vx-col sm:w-2/3 w-full">
        <multiselect
            class="selectExample"
            v-model="customerCategory.selected"
            :options="customerCategory.options"
            :show-labels="false"
            multiple
            :allow-empty="true"
            :group-select="false"
            :max-height="160"
            placeholder=" Type to search"
            track-by="ID"
            label="classification"
            name="customercategory"
            @input="selectSomeCustomerCategory"
          >
            <template slot="singleLabel" slot-scope="props">
              <span class="option__desc">
                <span class="option__title">{{ props.option.classification }}</span>
              </span>
            </template>

            <template slot="option" slot-scope="props">
              <div class="option__desc">
                <span class="option__title"> {{ props.option.classification }}</span>
              </div>
            </template>
          </multiselect>
      </div>
    </div>
    <div class="vx-row mb-6" style="width:50%">
      <div class="vx-col sm:w-1/3 w-full flex items-center">
          <span>Customer Group 1</span>&nbsp;
          <!-- <feather-icon title="Reset" icon="RefreshCwIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" class="ml-2" @click.stop="resetDateFilter('posting')"/> -->
      </div>
      <div class="vx-col sm:w-2/3 w-full">
        <multiselect
          class="selectExample"
          v-model="customerGroup.selected"
          :options="customerGroup.options"
          :show-labels="false"
          multiple
          :allow-empty="true"
          :group-select="false"
          :max-height="160"
          placeholder=" Type to search"
          track-by="ID"
          label="code"
          name="customergroup"
          @input="selectSomeCustomerGroup"
        >
          <template slot="singleLabel" slot-scope="props">
            <span class="option__desc">
              <span class="option__title">{{ props.option.code }}</span>
            </span>
          </template>

          <template slot="option" slot-scope="props">
            <div class="option__desc">
              <span class="option__title"> {{ props.option.code }}</span>
            </div>
          </template>
        </multiselect>
      </div>
    </div>
    <div class="vx-row mb-6" style="width: 50%">
      <div class="vx-col sm:w-1/3 w-full flex items-center">
          <span>Customer</span>
      </div>
      <div class="vx-col sm:w-2/3 w-full">
          <!-- <customer-filter :full="true" :hideLabel="true" /> -->
        <multiselect
          class="selectExample"
          v-model="customer.selected"
          :options="customer.options"
          :multiple="true"
          :allow-empty="true"
          :group-select="false"
          :max-height="160"
          :limit="4"
          placeholder=" Type to search"
          :internal-search="true"
          track-by="id"
          label="code"
          :custom-label="customLabelCustomer"
          :disabled="false"
        />
      </div>
    </div>
    <div class="vx-row mb-6" style="width:50%">
        <div class="vx-col sm:w-1/3 w-full flex items-center">
            
        </div>
        <div class="vx-col sm:w-2/3 w-full">
            <vs-button class="ml-4 mt-2 vx-col sm:w-2/4" color="primary" icon-pack="feather" icon="icon-download" @click="handleExport('excel')">Export</vs-button>
            <vs-button class="ml-4 mt-2 vx-col sm:w-2/4" color="primary" icon-pack="feather" icon="icon-refresh-cw" @click="getData()">Refresh</vs-button>
        </div>
    </div>
    <vs-table search stripe border description :sst="true" :data="table.data" :max-items="table.length"
      :total="table.total" @search="handleSearch" @change-page="handleChangePage" @sort="handleSort">
      <template slot="header">
        <vs-dropdown vs-trigger-click class="cursor-pointer">
          <div class="
              p-3
              border border-solid
              d-theme-border-grey-light
              rounded-full
              d-theme-dark-bg
              cursor-pointer
              flex
              items-center
              justify-between
              font-medium
            ">
            <span class="mr-2">{{ this.table.start }} - {{ this.table.end }} of
              {{ this.table.total }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu>
            <vs-dropdown-item v-for="item in table.limits" :key="item" @click="handleChangelength(item)">
              <span>{{ item }}</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </template>
      <template slot="thead">
        <!-- <vs-th></vs-th> -->
        <vs-th v-for="(head, index) in this.table.heads" :key="index" :sort-key="head.field">{{ head.title }}</vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <!-- <vs-td> </vs-td> -->
          <vs-td v-for="(head, index) in table.heads" :key="index" :data="data[indextr][head.field]"><a target="_blank"
              v-if="
                head.field == 'file_path' && data[indextr]['file_path'] != ''
              " :href="data[indextr]['file_path']">{{ data[indextr]["file_name"] }}</a>
            <span v-else-if="
              head.field == 'file_path' && data[indextr]['file_path'] == ''
            ">{{ data[indextr]["file_name"] }}</span>
            <span v-else-if="head.field == 'created_at'">{{
            dateFormat(data[indextr][head.field])
            }}</span>
            <span v-else>{{ data[indextr][head.field] }}</span>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <vs-pagination style="padding-top: 5px" :total="table.totalPage" v-model="setPage" />
  </div>
</template>
<script>
import moment from "moment";
import DateRangePicker from "vue2-daterange-picker";
import Datepicker from "vuejs-datepicker";
//you need to import the CSS manually
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import customer from "../../../../store/modules/customer";
import customerFilter from "../../../../components/customerFilter/customerFilter.vue";
import territoryFilter from "../../../../components/operatingUnitFilter/territoryFilter.vue";
import Territory from "../../../../components/master/Territory.vue";
export default {
  components: {
    // monitoring,
    Datepicker,
    DateRangePicker,
    // DataTableExport,
    "customer-filter": customerFilter,
    "territory-filter": territoryFilter,
  },
  data() {
    return {
      deleteId: null,
      table: this.tableDefaultState(),
      filterPostingDate: {
        startDate: null,
        endDate: null,
      },
      openKeyDate: new Date(),
      customerGroup: {
        selected: [],
        options: [],
      },
      customerCategory: {
        selected: [],
        options: [],
      },
      customer: {
        selected: [],
        options: [],
        search: "",
      },
    };
  },
  methods: {
    tableDefaultState() {
      return {
        data: [],
        length: 10,
        page: 1,
        search: "",
        order: "id",
        sort: "desc",
        total: 0,
        totalPage: 0,
        totalSearch: 0,
        limits: [10, 25, 50, 100, "All"],
        start: 1,
        end: 0,
        heads: [
          {
            field: "created_at",
            title: "Created At",
          },
          {
            field: "created_by",
            title: "Created By",
          },
          {
            field: "file_path",
            title: "File",
          },
          {
            field: "status",
            title: "Status",
          },
        ],
      };
    },
    handleSearch(searching) {
      this.table.search = searching;
      this.table.page = 1;
      this.getData();
    },
    handleChangePage(page) {
      this.table.page = page;
      this.getData();
    },
    handleSort(key, active) {
      this.table.order = key;
      this.table.sort = active;
      this.getData();
    },
    handleChangelength(val) {
      this.table.length = val == "All" ? this.table.total : val;
      this.table.page = 1;
      this.getData();
    },
    handleClose() {
      this.getData();
      this.$emit("close");
    },
    customLabelCustomer({ code, name }) {
      return `${code} - ${name}`;
    },
    handlerSearchCustomer(searching) {
      this.customer.option = [];
      this.customer.selected = [];
      this.customer.search = searching;
      this.getAllCustomerByTerritory(searching);
    },
    selectedSomeTerritory() {
      this.customer.options = [];
      this.customer.selected = [];
      this.getAllCustomerByTerritory("");
    },
    selectSomeCustomerCategory() {
      this.customer.options = [];
      this.customer.selected = [];
      this.getAllDataCustomerGroup();
      this.getAllCustomerByTerritory("");
    },
    selectSomeCustomerGroup() {
      this.customer.options = [];
      this.customer.selected = [];
      this.getAllCustomerByTerritory("");
    },
    getAllCustomerByTerritory(query) {
      this.customer.options = [];
      this.customer.selected = [];

      let territory_ids =
        this.$store.getters["operatingUnit/getSelectedTerritoryId"];

      let customer_group_ids = this.customerGroup.selected.filter(v => v.ID !== 0).map((v) => v.ID)
      let customer_category_ids = this.customerCategory.selected.filter(v => v.ID !== 0).map((v) => v.ID)

      this.$http
        .get("/api/v1/master/customer-by-territories-v3", {
          params: {
            territory_id: territory_ids,
            customer_category_id: customer_category_ids,
            customer_group_id: customer_group_ids,
            search: query ? query : "",
            // status: this.table.status,
          },
        })
        .then((resp) => {
          if (resp.status == "success") {
            // let all = {
            //   id: 0,
            //   code: "All",
            //   name: "-",
            // };
            // resp.data.unshift(all);
            // this.optionCustomer = resp.data;
            this.customer.options = resp.data;
          } else {
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    getCustomerCategory() {
      this.$vs.loading();
      this.$http
        .get("/api/v1/master/customer-category-all", {
          params: {
            order: "name",
            sort: "asc",
          },
        })
        .then((resp) => {
          if (resp.status == "success") {
            let all = {
              id: 0,
              classification: "All",
            };
            // resp.data.unshift(all);
            // this.optionCustomerCategory = resp.data;
            this.customerCategory.options = resp.data;
            this.customerCategory.selected.push({
              ID: 0,
              classification: "All",
            });
            this.$vs.loading.close();
          } else {
            this.$vs.loading.close();
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    getAllDataCustomerGroup() {
      this.$vs.loading();
      let customer_category_ids = this.customerCategory.selected.filter(v => v.ID !== 0).map((v) => v.ID)

      this.$http
        .get("/api/v1/master/customer-group-limit-export", {
          params: {
            order: "name",
            sort: "asc",
            level: 1,
            customer_category_ids,
          },
        })
        .then((resp) => {
          if (resp.status == "success") {
            // resp.data.records.unshift({
            //   ID: 0,
            //   code: "All",
            // });
            this.customerGroup.options = resp.data.records;
            this.customerGroup.selected.push({
              ID: 0,
              code: "All",
            });
            this.$vs.loading.close();
          } else {
            this.$vs.loading.close();
          }
        });
    },
    getData() {
      this.$vs.loading();
      this.$http
        .get("/api/v1/report/debit-note/table-export", {
          params: {
            length: this.table.length,
            page: this.table.page,
            search: this.table.search,
            order: this.table.order,
            sort: this.table.sort,
            type: "report-customer-limit",
          },
        })
        .then((resp) => {
          if (resp.status == "success") {
            this.table.total = resp.data.total_record;
            this.table.totalPage = resp.data.total_page;
            this.table.totalSearch = resp.data.total_record_search;
            this.table.length = resp.data.total_record_per_page;
            this.table.data = resp.data.records;
            this.setStartEnd();
            this.$vs.loading.close();
          } else {
            this.$vs.loading.close();
          }
        });
    },
    handleExport(file) {
      this.$vs.loading();
      // let customer_ids =
      //   this.$store.getters["customerFilter/getSelectedCutomerIDs"];
      // if (!customer_ids || customer_ids.includes(0)) {
      //   customer_ids = [];
      // }

      let territory_ids =
        this.$store.getters["operatingUnit/getSelectedTerritoryId"];

      let customer_group_ids = this.customerGroup.selected.filter(v => v.ID !== 0).map((v) => v.ID)
      let customer_category_ids = this.customerCategory.selected.filter(v => v.ID !== 0).map((v) => v.ID)
      let customer_ids = this.customer.selected.filter(v => v.id !== 0).map((v) => v.id)

      var fileTitle =
          "customer_limit" +
          "_" +
          moment(this.startDate).format("YYYY-MM-DD") +
          "_-_" +
          moment(this.endDate).format("YYYY-MM-DD");

      this.$http
          .get("/api/v1/report/customer-limit/export", {
          params: {
              order: this.table.order,
              sort: this.table.sort,
              file: file,
              title: fileTitle,
              territory_ids,
              customer_ids,
              customer_group_ids,
              customer_category_ids,
          },
          })
          .then((resp) => {
          this.$vs.loading.close();
          if (resp.status == "error") {
            this.$vs.notify({
              color: "danger",
              title: "Error",
              text: resp.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
            });
          } else {
            this.getData();
            this.$vs.notify({
              color: "success",
              title: "Processing",
              text: resp.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
            });
          }
      });
    },
    setStartEnd() {
      let valStart =
        this.table.length * this.table.page - this.table.length + 1;

      if (valStart > this.table.total) {
        valStart = 1;
      }
      if (this.table.total == 0) {
        valStart = 0;
      }
      let valEnd = this.table.length * this.table.page;

      if (valEnd > this.table.total) {
        valEnd = this.table.total;
      }

      if (
        this.table.totalSearch < this.table.total &&
        this.table.search != ""
      ) {
        valEnd = this.table.totalSearch;
      }

      this.table.start = valStart;
      this.table.end = valEnd;
    },
    dateFormat(val) {
      //return moment(val).local();
      return moment(val)
				.add(-7, "h")
				.utc()
				.local();
    },
    datePickerDateFormat(date) {
        let a = null;
        if (date != null) {
            a = moment(date).format("dddd, MMMM Do YYYY");
        }
        return a;
    },
  },
  watch: {
    detail() {
      this.getData();
    },
    startDate() {
      this.getData();
    },
    endDate() {
      this.getData();
    },
    "customerGroup.selected": function () {
      if (this.customerGroup.selected.length > 1) {
        for (
          let index = 0;
          index < this.customerGroup.selected.length;
          index++
        ) {
          if (this.customerGroup.selected[index].ID == 0) {
            this.customerGroup.selected.splice(index, 1);
            // this.customerGroup.selected = {
            //   ID: 0,
            //   code: "All",
            // };
          }
        }
      } else if (this.customerGroup.selected.length == 0) {
          this.customerGroup.selected.push({
            ID: 0,
            code: "All",
          });
      }
    },
    "customerCategory.selected": function () {
      if (this.customerCategory.selected.length > 1) {
        for (
          let index = 0;
          index < this.customerCategory.selected.length;
          index++
        ) {
          if (this.customerCategory.selected[index].ID == 0) {
            this.customerCategory.selected.splice(index, 1);
          }
        }
      } else if (this.customerCategory.selected.length == 0) {
        this.customerCategory.selected.push({
          ID: 0,
          classification: "All",
        });
      }
    },
    "customer.selected": function () {
      console.log("customer.selected", this.customer.selected.length);
      if (this.customer.selected.length > 1) {
        console.log("customer.selected 1");
        for (
          let index = 0;
          index < this.customer.selected.length;
          index++
        ) {
          if (this.customer.selected[index].id == 0) {
            this.customer.selected.splice(index, 1);
          }
        }
      } else if (this.customer.selected.length == 0) {
        console.log("customer.selected 0");
        this.customer.selected.push({
          id: 0,
          code: "All",
          name: "All",
        });
      }
    },
  },
  computed: {
    setPage: {
      get() {
        return 1;
      },
      set(val) {
        this.handleChangePage(val);
      },
    },
  },
  mounted() {

    const today = new Date();
    this.filterPostingDate.startDate = new Date(today.getFullYear(), today.getMonth(), 1);
    this.filterPostingDate.endDate = new Date(today.getFullYear(), today.getMonth()+1, 0);
    this.getAllDataCustomerGroup();
    this.getCustomerCategory();
    this.getAllCustomerByTerritory("");
  },
};
</script>